import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GlassIcon from './GlassIcon';

const AVATAR_GRADIENT = 'tw-from-teal-400 tw-to-cyan-500 tw-shadow-teal-500/30';

const IMAGE_SIZES = {
  md: 'tw-h-8 tw-w-8',
  lg: 'tw-h-11 tw-w-11',
};

const ICON_SIZES = { md: 'avatar', lg: 'avatarLg' };

export const getInitials = (firstName, lastName) =>
  `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toLocaleUpperCase('tr-TR') || '?';

/** Profile photo, or the user's initials on a glass disc when there is none. */
const Avatar = ({ firstName, lastName, imageUrl, onImageError, size = 'md' }) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  if (imageUrl && !imageFailed) {
    return (
      <img
        src={imageUrl}
        alt=""
        onError={() => {
          setImageFailed(true);
          if (onImageError) onImageError();
        }}
        className={`tw-shrink-0 tw-rounded-full tw-object-cover tw-ring-2 tw-ring-white/80 dark:tw-ring-white/15 ${IMAGE_SIZES[size]}`}
      />
    );
  }

  return (
    <GlassIcon gradient={AVATAR_GRADIENT} size={ICON_SIZES[size]}>
      {getInitials(firstName, lastName)}
    </GlassIcon>
  );
};

Avatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  imageUrl: PropTypes.string,
  onImageError: PropTypes.func,
  size: PropTypes.oneOf(Object.keys(IMAGE_SIZES)),
};

export default Avatar;
